const MESSAGES: ReadonlyMap<SessionTokenError['reason'], string> = new Map([
  ['token-malformed', 'The issued session token is not a well-formed Sanctum token'],
  ['token-missing', 'A successful sign-in returned no session token']
])

// Never carries the token value; the reason is what a catcher and a log line need.
export class SessionTokenError extends Error {
  public readonly reason: 'token-malformed' | 'token-missing'

  public constructor(reason: SessionTokenError['reason']) {
    super(`${MESSAGES.get(reason) ?? reason} (${reason})`)
    this.name = 'SessionTokenError'
    this.reason = reason
  }
}
